import { formaters } from "vincent-utils";
import _ from "underts";
import Select2 from "./Select2";

interface HMInputProps {
  hmPossibles: { hour: number; minute: number }[];
  handleHMChange: (hm: { hour: number; minute: number }) => void;
  hmSelected: { hour: number; minute: number };
}

const HMInput = (props: HMInputProps) => {
  const { hmPossibles, handleHMChange, hmSelected } = props;

  const handleHMStringChange = (hmString: string) => {
    const hm = formaters.getHourMinuteObjectFromHoraireString(hmString);
    if (hm) {
      handleHMChange(hm);
    }
  };
  const hmStrings =
    hmPossibles &&
    hmPossibles
      .map(formaters.formatHourMinuteObjectForDisplay)
      .map(formaters.nullToEmptyString);
  const hmKeyMap = hmStrings.reduce(
    (acc, hmString) => {
      acc[hmString] = hmString;
      return acc;
    },
    {} as { [key: string]: string }
  );
  if (!_.isNonEmpty(hmStrings)) {
    return null;
  }
  return (
    <Select2
      keyMap={hmKeyMap}
      onSelect={handleHMStringChange}
      selected={formaters.formatHourMinuteObjectForDisplay(hmSelected)}
      defaultKey={_.head(hmStrings) || ""}
      className={""}
      id="heure_minute_chooser"
    />
  );
};

export default HMInput;
